import script from "./OrderWaitingNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderWaitingNotification.vue?vue&type=script&setup=true&lang=js"

import "./OrderWaitingNotification.vue?vue&type=style&index=0&id=0690e73e&lang=scss"

const __exports__ = script;

export default __exports__